import api from 'api/apiInstance';

// Post-meeting AI coaching for advisers. NOTE: unlike meetingSummary (JSON:API),
// the coaching Grape endpoint returns this plain hash directly — so consumers read
// `response.data`, NOT `response.data.data.attributes`.
export interface AdviceRoomCoaching {
  meeting_id: number;
  adviser_id: number | null;
  generated_at: string;
  source: string; // 'stub' while canned; future 'live' once the AI service is wired
  coaching: {
    score: number;
    strengths: string[];
    improvements: string[];
    next_steps: string[];
  };
  // NOTE: no transcript content is sent over the wire — the backend stub
  // deliberately omits it (data minimisation, UK GDPR Art 5(1)(c); see T4).
}

export function adviceRoomAiCoachingApi(path: string) {
  return {
    path,
    GET: () =>
      api.get<AdviceRoomCoaching>(path, {
        // Custom interceptor flag (mirrors meetingSummary). Coaching returns
        // 403 (client / cross-tenant) or 404 (no consent / no transcript);
        // the panel renders nothing rather than redirecting.
        skipRedirect: true,
      }),
  };
}
